import React, { useState, useContext } from 'react';
import cl from 'classnames';

import classes from '../../filterBar.module.scss';
import styles from './styles.module.scss';
import { FilterContext } from '../../context';

import LayoutFilterOption from '../LayoutFilterOption';
// import BudgetFilterOption from '../BudgetFilterOption';
import MoreFiltersOption from '../MoreFiltersOption';

const MoreFilters = props => {
  const { isMobileDevice } = props;
  const [isActive, setIsActive] = useState(false);
  const { setActiveFilter } = useContext(FilterContext);

  const toggleFilter = () => {
    setActiveFilter(null);
    setIsActive(!isActive);
  };

  const content = isMobileDevice ? (
    <>
      <LayoutFilterOption />
      {/* <BudgetFilterOption /> */}
      <MoreFiltersOption />
    </>
  ) : (
    <div
      className={cl(classes.FilterOption, {
        [classes['FilterOption--focused']]: isActive,
      })}>
      <button type='button' onClick={() => toggleFilter()}>
        More filters
      </button>

      <div
        className={cl(styles.MoreFiltersContent, {
          [styles['MoreFiltersContent--isActive']]: isActive,
        })}>
        <LayoutFilterOption />
        {/* <BudgetFilterOption /> */}
        <MoreFiltersOption />
      </div>
    </div>
  );

  return content;
};

export default MoreFilters;
